import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Codepen = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M21.838 8.445c0-.001-.001-.001 0 0l-.003-.004-.001-.001v-.001a.809.809 0 00-.235-.228l-9.164-6.08a.834.834 0 00-.898 0L2.371 8.214A.786.786 0 002 8.897v6.16a.789.789 0 00.131.448v.001l.002.002.01.015v.002h.001l.001.001.001.001c.063.088.14.16.226.215l9.165 6.082a.787.787 0 00.448.139.784.784 0 00.45-.139l9.165-6.082a.794.794 0 00.371-.685v-6.16a.793.793 0 00-.133-.452zm-9.057-4.172l6.953 4.613-3.183 2.112-3.771-2.536V4.273zm-1.592 0v4.189l-3.771 2.536-3.181-2.111 6.952-4.614zm-7.595 6.098l2.395 1.59-2.395 1.611v-3.201zm7.595 9.311l-6.96-4.617 3.195-2.15 3.765 2.498v4.269zm.795-5.653l-3.128-2.078 3.128-2.105 3.131 2.105-3.131 2.078zm.797 5.653v-4.27l3.766-2.498 3.193 2.15-6.959 4.618zm7.597-6.11l-2.396-1.611 2.396-1.59v3.201z",
    key: "k0"
  }));
});
Codepen.displayName = 'Codepen';
export var CodepenDimensions = {
  height: 24,
  width: 24
};